// src/config.js
const config = {
  pageSize: 10,
//   DTempUrl: "https://fireboltt.nuralservice.com/Excel/Templates/"
};

export default config;
